// THIS IS A GENERATED FILE, DO NOT EDIT!

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AlertSource": [
      "ExpensesExpensable",
      "FinanceSpendingPolicy",
      "FinanceSpendingPolicyRuleGroup"
    ],
    "AlertTarget": [
      "ExpensesExpensable",
      "FinanceSpendingPolicyRuleGroup"
    ],
    "AmountStrategy": [
      "ContractsFixedAmountStrategy",
      "ContractsVariableAmountStrategy"
    ],
    "Approvable": [
      "AtsRequisition",
      "AttendanceEditTimesheetRequest",
      "AttendanceOvertimeRequest",
      "BankingCard",
      "ContractsContractVersion",
      "ContractsContractVersionRequest",
      "ExpensesExpensable",
      "IntegrationsJoinOrder",
      "ProcurementPurchaseRequest",
      "ShiftManagementSwapShift",
      "TimeoffLeave",
      "TrainingsTrainingRequest"
    ],
    "CompensationsAmountStrategy": [
      "CompensationsFixedAmountStrategy",
      "CompensationsVariableAmountStrategy"
    ],
    "Contentable": [
      "TrainingsContentBlockPage",
      "TrainingsContentBlockQuiz",
      "TrainingsContentBlockVideo"
    ],
    "IntegrationsSyncable": [
      "CompensationsPayrollRunEmployeesCompensation"
    ],
    "MaterializedFormResource": [
      "TrainingsTrainingClass"
    ],
    "MutationError": [
      "SimpleError",
      "StructuredError"
    ],
    "PerformanceQuestionnaireable": [
      "PerformanceReviewProcess",
      "PerformanceReviewProcessCustomTemplate"
    ],
    "RateResource": [
      "EmployeesEmployee",
      "JobCatalogLevel",
      "JobCatalogTreeLevel",
      "ProjectManagementProject",
      "ProjectManagementProjectWorker"
    ],
    "Taskable": [
      "ApprovalsMaterializedApprovalStep",
      "ApprovalsV2ReviewRequest",
      "BookkeepersManagementIncidence",
      "DocumentsDocument",
      "EmployeesEmployeeName",
      "EsignatureSignature",
      "FormsMyMembership",
      "PerformanceReviewEvaluationAnswer",
      "PerformanceReviewProcessMaterializedTarget",
      "ProcurementUploadDocumentTask",
      "WorkflowsWorkflowHandlerExecution"
    ]
  }
};
      export default result;
    